export const config = {
    appname: 'splus',
    client_id: '320639158447301', // App ID
    facebook_app_id: '320639158447301', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Staging Settings ----------------
    api: 'stg3',
    agency_id: '110680',
    bzbsUrl: 'https://apisps2.buzzebees-uat.com',
    bzbsModuleUrl: 'https://splusmodule.buzzebees-uat.com',
    apiShoppingCartUrl: 'https://shoppingcartmodule27.buzzebees-uat.com',
    webShoppingCartUrl: 'https://shoppingcartservice27.buzzebees-uat.com',
    bzbsBlobUrl: 'https://stgstoragebuzzebees.blob.core.windows.net',
    miscUrl: 'https://misc.buzzebees-uat.com',
    authSofin: 'https://webtest.s-sofin.com/bzb-authen-uat/',
    webSofinUrl: 'https://webtest.s-sofin.com/bzb-authen-uat',
    bzbsGaId: '',
    liffId: '',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],
    cateIdNotification: {
        catActivityId: 9431336,
        catNewsId: 9431332,
        catProductId: 9431335,
        catPrivilegeId: 9431333,
        catRewardId: 9440044,
    },
    firebase: {
        apiKey: "AIzaSyBl1ijCZGhZ6JdPkb5yyM-5JBnQkOy1fqM",
        authDomain: "splus-staging.firebaseapp.com",
        databaseURL: "https://splus-staging.firebaseio.com",
        projectId: "splus-staging",
        storageBucket: "splus-staging.appspot.com",
        messagingSenderId: "6365351631",
        appId: "1:6365351631:web:943efa542f298d671c71ba",
        measurementId: "G-Q266BSDP7E"
    },
};
